class Logger {

  // Vars
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	static NAME = 'Logger';

	static styleBold = [
		'color: white',
		'font-weight: bold',
	].join(';');

	static styleError = [
		'color: red',
		'text-align: left',
	].join(';');

	static styleSubdued = [
		'color: gray',
		'font-weight: normal'
	].join(';');

  // Logic
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

  static error(message, ...args) {
  	console.trace("%c" + message, this.styleError, ...args)
  }

  static info(message, ...args) {
  	console.info("%c" + message, this.styleSubdued, ...args)
  }

	static log(message, ...args) {
		console.log("%c" + message, this.styleBold, ...args);
	}
}

// Not in a static block: esbuild renames the class to `var xe = class { static { ... } }`
// and rewrites `this`/`Logger` inside the block to `xe`, which is still undefined there.
Logger.info(`${Logger.NAME} > init`);

export default Logger;
